// extracted by mini-css-extract-plugin
export default {"gallery":"MediaMessage_gallery__JhHDd"};